import { Box } from '@mui/system'
import { useEffect, useState } from 'react'

import { Typography, useMediaQuery } from '@mui/material'
import Image from '@components/Image'
import { BsQuestionSquare } from 'react-icons/bs'
import useAPIFetch from '@hooks/useAPIFetch'
import { useMeta } from '@contexts/Meta'
import useLocalStorage from '@hooks/useLocalStorage'
import UserService from '@services/users/user.service'

interface ComponentIconProps {
	component: any
	projectId: string
}

export const ComponentIcon = ({ component }: ComponentIconProps) => {
	const enableClick = component['enable']
	const { isLoading } = useAPIFetch()
	const [, { setMeta }] = useMeta()
	const [isHoverIcon, setIsHoverIcon] = useState(false)

	const isSmallScreen = useMediaQuery('(max-width:1180px)')
	const backgroundColorSelection = (productCode: string) => {
		switch (productCode) {
			case 'SSSS Dashboard':
				return '#4BBE55'
			case 'CDE':
				return '#D77ECA'
			case 'Varadise Twin':
				return '#5D7DC1'
			case 'DWSS':
				return '#2891A0'
			case 'Project Finance':
				return '#E8C843'
			case 'BIM 360':
				return '#EF9148'
			case 'Chatbot':
				return '#D8AE50'
			case 'GPS':
				return '#EA6565'
			default:
				return 'info'
		}
	}

	const handleClick = async () => {
		if (component.url && enableClick) {
			window.open(`${component.url}`)

			// UserService.CreateAuditTrail({
			// 	date: new Date().toISOString(),
			// 	message: `Visiting '${component.display_name}'`,
			// 	eventType: 'VISIT',
			// 	status: 'SUCCESS',
			// })
		}
	}

	useEffect(() => {
		setMeta({ isLoading })
	}, [isLoading])

	return (
		<Box
			sx={{
				minHeight: isSmallScreen ? '93px' : '125px',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				cursor: 'pointer',
			}}
			onClick={handleClick}
		>
			<Box
				sx={{
					width: isSmallScreen ? '50px' : '75px',
					height: isSmallScreen ? '50px' : '75px',
					color: '#707070',
					backgroundColor:
						enableClick && isHoverIcon ? backgroundColorSelection(component.code) : '#FFFFFF',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					borderRadius: '10px',
				}}
				onMouseOver={() => setIsHoverIcon(true)}
				onMouseOut={() => setIsHoverIcon(false)}
			>
				{component.icon_url ? (
					<Image
						src={component.icon_url}
						width={isSmallScreen ? 35 : 50}
						height={isSmallScreen ? 35 : 50}
						themeColor={enableClick ? undefined : 'info'}
					/>
				) : (
					<BsQuestionSquare
						style={{
							fontSize: isSmallScreen ? '40px' : '50px',
							color: enableClick ? (isHoverIcon ? 'white' : '#4BBE55') : 'grey',
						}}
					/>
				)}
			</Box>
			<Typography
				sx={{ maxWidth: '90px', maxHeight: '45px', marginTop: '3px', textAlign: 'center' }}
				variant={isSmallScreen ? 'body2' : 'h5'}
				color={enableClick ? 'white' : 'darkGrey'}
				noWrap={false}
			>
				{component['display_name']}
			</Typography>
		</Box>
	)
}
